import { Button, ErrorMessage, FieldLabel, Modal, ModalContent, ModalHeader, ModalSidebar, TextInput, } from '@lightspeed/design-system-react';
import { T, useT, UT } from '@transifex/react';
import { VendImage } from '@vend/react-utilities';
import React, { useEffect, useState } from 'react';
import { withTranslations } from '../../tx';
const recoveryCodeRegexp = /^[0-9A-Z]{4}-[0-9A-Z]{4}-[0-9A-Z]{4}$/;
const recoveryCodeLength = 14;
const validateRecoveryCode = (code) => {
    return code.length === recoveryCodeLength && recoveryCodeRegexp.test(code);
};
const RecoveryCodeModalUnconnected = ({ onBack, onSubmit, isSubmitting, isInvalidCode, onClose, authType = 'signin', dismissable = true, }) => {
    const t = useT();
    const isSignin = authType === 'signin';
    const invalidCodeErrMessage = t('Invalid recovery code entered. Please try again.', {
        _context: 'erorr message for invalid recovery code entered on the recovery code modal',
    });
    const [recoveryCode, setRecoveryCode] = useState('');
    const [showInvalidCodeError, setShowInvalidCodeError] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(true);
    useEffect(() => {
        if (isSubmitting) {
            return;
        }
        setShowInvalidCodeError(isInvalidCode);
    }, [isInvalidCode, isSubmitting]);
    const onRecoveryCodeChange = (code) => {
        setShowInvalidCodeError(false);
        if (validateRecoveryCode(code)) {
            setRecoveryCode(code);
            setSubmitDisabled(false);
        }
        else {
            setSubmitDisabled(true);
        }
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        if (!validateRecoveryCode(recoveryCode)) {
            setShowInvalidCodeError(true);
            return;
        }
        const mfaInput = {
            type: 'OTP',
            recovery_code: recoveryCode,
        };
        onSubmit(mfaInput);
    };
    return (React.createElement(Modal, { focusTrapActive: !isSignin, pageModal: isSignin, size: isSignin ? 'medium-with-sidebar' : 'small-with-sidebar', onClose: onClose, dismissable: dismissable },
        React.createElement(ModalSidebar, { className: "vd-flex vd-align-center" },
            React.createElement(VendImage, { className: "mfa-modal-sidebar-image", relativeImagePath: "signin/enter_recovery_code-v1.svg", alt: t('recovery code image', { _context: 'image alt' }) })),
        React.createElement(ModalHeader, null, isSignin
            ? t('Enter a recovery code to finish signing in', {
                _context: 'recovery code modal header',
            })
            : t('Enter a recovery code to finish user switching', {
                _context: 'recovery code modal header',
            })),
        React.createElement(ModalContent, null,
            React.createElement("div", { className: "vd-body--no-scroll" },
                React.createElement("div", { className: "vd-p" },
                    React.createElement(T, { _str: "If you have lost access to your authentication app, enter one of your recovery codes. This code can\u2019t be used a second time. {recoveryCodeArticleLink}", recoveryCodeArticleLink: React.createElement(UT, { _str: '<a href="https://support.vendhq.com/hc/en-us/articles/360003973336" class="vd-link" rel="noopener noreferrer" target="_blank">What are recovery codes?</a>', _comment: "Link for recoveryCodeArticleLink" }) })),
                React.createElement("form", { onSubmit: handleSubmit },
                    React.createElement("div", { className: "vd-field" },
                        React.createElement(FieldLabel, { htmlFor: "recovery-code", label: t('Recovery Code', {
                                _context: 'Label for the form input to enter a recovery code',
                            }) }),
                        React.createElement(TextInput, { autoFocus: true, name: "recovery-code", placeholder: t('Enter your recovery code'), hasError: showInvalidCodeError && Boolean(recoveryCode), onChange: e => onRecoveryCodeChange(e.target.value) }),
                        showInvalidCodeError && Boolean(recoveryCode) && (React.createElement(ErrorMessage, null, invalidCodeErrMessage))),
                    React.createElement("div", { className: "vd-flex vd-flex--align-center vd-flex--justify-between vd-pt3" },
                        React.createElement(UT, { _str: '<a href="https://support.vendhq.com/hc/en-us/articles/360003973336" class="vd-link" rel="noopener noreferrer" target="_blank">I can’t access my recovery codes.</a>' }),
                        React.createElement("div", { className: "vd-btn-group" },
                            React.createElement(Button, { "data-track": "recovery-code-modal-back", className: "vd-mr2", variant: "supplementary", onClick: onBack }, t('Back')),
                            React.createElement(Button, { "data-track": `recovery-code-modal-${isSignin ? 'sign-in' : 'switch-user'}`, variant: "go", type: "submit", disabled: submitDisabled && !isSubmitting, loading: isSubmitting }, isSignin
                                ? t('Sign in', { _context: 'recovery code modal - button' })
                                : t('Switch user', {
                                    _context: 'recovery code modal - button',
                                })))))))));
};
export const RecoveryCodeModal = withTranslations(RecoveryCodeModalUnconnected, 'RecoveryCodeModal');
